globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Reviews = appCustomerSpace.Modals.Reviews || {};

appCustomerSpace.Modals.Reviews.SelectRequestTemplate = (function(superClass) {

  utils.extend(SelectRequestTemplate, superClass);

  function SelectRequestTemplate($html) {
    this.$html = $html;
    return SelectRequestTemplate.__super__.constructor.apply(this, arguments);
  }

  $.extend(SelectRequestTemplate.prototype, {
    init: function() {
      var modal = this;

      SelectRequestTemplate.__super__.init.apply(this, arguments);

      SearchFilter.initFilters(this.$html.find('.input-filter'));

      this.$html.find('.media-link').each(function() {
        $(this).on('click', function(e) {
          e.preventDefault();
          var selectedTemplateId = $(this).data('template-id');

          modal.close();
          appCustomerSpace.currentController.loadRequestTemplate(selectedTemplateId);
        });
      })
    }
  });

  return SelectRequestTemplate;
})(appCustomerSpace.Modal);
